/* Keep audited multi-configuration dimensions in sync with the selected variant. */
if (!customElements.get('ck-audited-dimensions')) {
  customElements.define('ck-audited-dimensions', class extends HTMLElement {
    connectedCallback() {
      const source = this.querySelector('[data-audit-variants]');
      if (!source) return;
      this.config = JSON.parse(source.textContent);
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      document.addEventListener('variant:update', event => {
        const variant = event.detail?.resource;
        if (variant?.id) this.update(String(variant.id).split('/').pop());
      }, options);
      document.addEventListener('change', event => {
        if (!event.target.closest('.product-information, product-information, variant-picker')) return;
        const selected = event.target instanceof HTMLSelectElement ? event.target.selectedOptions[0] : event.target;
        const selectedId = selected?.dataset.variantId;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.update(selectedId || new URL(location.href).searchParams.get('variant')), 400);
      }, options);
      window.addEventListener('popstate', () => this.update(new URL(location.href).searchParams.get('variant')), options);
    }
    disconnectedCallback() { this.controller?.abort(); clearTimeout(this.timer); }
    update(id) {
      const variant = this.config.variants.find(item => item.id === String(id));
      if (!variant || this.dataset.variant === String(id)) return;
      this.dataset.variant = String(id);
      this.querySelectorAll('[data-audit-width]').forEach(node => { node.textContent = variant.width; });
      if (variant.seatDepth != null) this.querySelectorAll('[data-audit-seat-depth]').forEach(node => { node.textContent = variant.seatDepth; });
      for (const [key, attr] of [['height', 'height'], ['seatHeight', 'seat-height'], ['sectionDepth', 'section-depth']]) {
        if (variant[key] != null) this.querySelectorAll(`[data-audit-${attr}]`).forEach(node => { node.textContent = variant[key]; });
      }
      const photo = this.config.photos[String(variant.width)];
      const figure = this.querySelector('.ck-audited-dims__figure');
      if (figure) figure.hidden = photo?.hidden === true;
      if (photo?.hidden) return;
      if (!photo) return;
      const { left, right, top, bottom } = photo;
      const y = bottom + 50, x = right + 40, mid = (bottom + top) / 2;
      const set = (selector, attributes) => {
        const node = this.querySelector(selector);
        if (node) Object.entries(attributes).forEach(([name, value]) => node.setAttribute(name, value));
      };
      set('[data-audit-photo]', { href: photo.url });
      set('.ck-audited-dims__photo', { viewBox: `-90 ${top - 100} 1200 ${bottom - top + 255}` });
      set('[data-audit-width-guides]', { d: `M${left} ${bottom}V${y + 12} M${right} ${bottom}V${y + 12}` });
      set('[data-audit-width-line]', { d: `M${left} ${y}H${right}` });
      set('[data-audit-width-label]', { x: (left + right) / 2, y: y + 43 });
      set('[data-audit-height-guides]', { d: `M${right} ${top}H${x + 12} M${right} ${bottom}H${x + 12}` });
      set('[data-audit-height-line]', { d: `M${x} ${top}V${bottom}` });
      set('[data-audit-height-label]', { x: x + 38, y: mid, transform: `rotate(-90 ${x + 38} ${mid})` });
    }
  });
}

